import { Module } from 'src/domain';
import { InheritanceLevelModel, ModuleEnum } from 'src/infrastructure/rest-api/api-types';

export function moduleToSplitKey(
    module: Module
): keyof Omit<InheritanceLevelModel, 'id' | 'entityId' | 'entityType' | 'noosShare' | 'salesBudget'> | null {
    switch (module) {
        case Module.CategorySplit:
            return 'categorySplit';
        case Module.GenderSplit:
            return 'genderSplit';
        case Module.ProductLineSplit:
            return 'productLineSplit';
        case Module.Markup:
            return 'markup';
        case Module.Markdown:
            return 'markdown';
        case Module.WeekCover:
            return 'weekCover';
        case Module.DeliveryProfile:
            return 'deliveryProfile';
    }
    return null;
}

export const moduleToModuleEnum = (currentModule: Module | undefined): ModuleEnum | null => {
    switch (currentModule) {
        case Module.StyleTimeline:
            return 'StyleTimeline';
        case Module.SalesCampaignsPlanning:
            return 'SalesCampaign';
        case Module.StoreInventoryManagement:
            return 'InventoryManagement';
        default:
            return null;
    }
};
